import {
	CheckoutStateActions,
	FETCH_VPC_PENDING,
	FETCH_VPC_SUCCESS,
	FETCH_VPC_FAILURE,
	SET_SCREENSHOT_SPINNER,
	SCREENSHOT_PENDING,
	SCREENSHOT_SUCCESS,
	YMAL_PIP_LINK_CLICK,
	SET_NO_SUMMARY_PAGE_BACK_BUTTON,
	SUMMARY_PAGE_TAB_CLICK,
	SET_VISIBLE_MODAL,
	SAVE_CONFIGURATION,
	SET_SAVED_VPC_CONFIGURATION,
	SET_DESIGN_SOURCE,
	SUMMARY_PAGE_EXPAND_PRODUCT,
	SHOW_ADD_TO,
	SET_UPPTACKA_SAVE_FAIL,
	SORT_PRODUCT_LIST,
	SET_TWO_SEPARATE_SOFAS,
	SET_SUMMARY_PAGE_DEFAULT_TAB,
	SET_SHOW_SUMMARY,
	SET_STOCKED_IKEA_PLUS,
	BACK_TO_SHARE_MENU,
} from './types';
import { SummaryPageTab, VisibleModal, DesignSourceFromUrl } from 'sofa-reborn-react';
import { COPY_CODE, SAVE_FOR_LATER_TAB_CLICK, SEND_EMAIL, SEND_SMS } from '.';
import { IVpcConfiguration } from '@inter-ikea-kompis/types';

export function fetchVpcPending(): CheckoutStateActions {
	return {
		type: FETCH_VPC_PENDING,
	};
}

export function fetchVpcSuccess(vpcCode: string | null): CheckoutStateActions {
	return {
		type: FETCH_VPC_SUCCESS,
		vpcCode,
	};
}

export function fetchVpcFailure(error: ErrorEvent): CheckoutStateActions {
	return {
		type: FETCH_VPC_FAILURE,
		message: error.message,
	};
}

export function setScreenshotSpinner(value: boolean): CheckoutStateActions {
	return {
		type: SET_SCREENSHOT_SPINNER,
		value,
	};
}

export function screenshotPending(): CheckoutStateActions {
	return {
		type: SCREENSHOT_PENDING,
	};
}

export function screenshotSuccess(data: string | null): CheckoutStateActions {
	return { type: SCREENSHOT_SUCCESS, data };
}

export function ymalPipLinkClick(value: string): CheckoutStateActions {
	return {
		type: YMAL_PIP_LINK_CLICK,
		value,
	};
}

export function setNoSummaryPageBackButton(value: boolean): CheckoutStateActions {
	return {
		type: SET_NO_SUMMARY_PAGE_BACK_BUTTON,
		value,
	};
}

export function summaryPageTabClick(value: SummaryPageTab): CheckoutStateActions {
	return {
		type: SUMMARY_PAGE_TAB_CLICK,
		value,
	};
}

export function setVisibleModal(value: VisibleModal | null): CheckoutStateActions {
	return {
		type: SET_VISIBLE_MODAL,
		value,
	};
}

export function saveConfiguration(): CheckoutStateActions {
	return {
		type: SAVE_CONFIGURATION,
	};
}

export function setSavedVpcConfiguration(value: IVpcConfiguration | null): CheckoutStateActions {
	return {
		type: SET_SAVED_VPC_CONFIGURATION,
		value,
	};
}

export function sendSms(): CheckoutStateActions {
	return {
		type: SEND_SMS,
	};
}

export function sendEmail(): CheckoutStateActions {
	return {
		type: SEND_EMAIL,
	};
}

export function copyCode(): CheckoutStateActions {
	return {
		type: COPY_CODE,
	};
}

export function backToShareMenu(value: string): CheckoutStateActions {
	return {
		type: BACK_TO_SHARE_MENU,
		value,
	};
}

export function saveForLaterTabClick(value: string): CheckoutStateActions {
	return {
		type: SAVE_FOR_LATER_TAB_CLICK,
		value,
	};
}

export function setDesignSource(value: DesignSourceFromUrl): CheckoutStateActions {
	return {
		type: SET_DESIGN_SOURCE,
		value,
	};
}

export function summaryPageExpandProduct(id: string, expand: boolean): CheckoutStateActions {
	return {
		type: SUMMARY_PAGE_EXPAND_PRODUCT,
		id,
		expand,
	};
}

export function setShowAddTo(value: { show: boolean; origin: string }): CheckoutStateActions {
	return {
		type: SHOW_ADD_TO,
		value,
	};
}

export function sortProductList(value: string): CheckoutStateActions {
	return {
		type: SORT_PRODUCT_LIST,
		value,
	};
}

export function setUpptackaSaveFail(value: boolean, error?: string): CheckoutStateActions {
	return {
		type: SET_UPPTACKA_SAVE_FAIL,
		value,
		error,
	};
}

export function setTwoSeparateSofas(value: boolean): CheckoutStateActions {
	return {
		type: SET_TWO_SEPARATE_SOFAS,
		value,
	};
}

export function setSummaryPageDefaultTab(value: string): CheckoutStateActions {
	return {
		type: SET_SUMMARY_PAGE_DEFAULT_TAB,
		value,
	};
}

export function setShowSummary(value: boolean): CheckoutStateActions {
	return {
		type: SET_SHOW_SUMMARY,
		value,
	};
}

export function setStockedIkeaPlus(value: boolean): CheckoutStateActions {
	return {
		type: SET_STOCKED_IKEA_PLUS,
		value,
	};
}
